import { useMemo } from 'react';

import AMP_KEYS from '@/configs/amp-track-keys';
import { DataTable, DataTableEmpty } from '@/shared/ui/data-table';
import { track } from '@/utils/track/track';

import { useIssueListActions } from '../../hooks/use-issue-list-query';
import {
  type CompositedSignalIssue,
  MAX_DISPLAY_ISSUE_COUNT,
  type SignalDateSelectionInput,
} from '../../model';
import { useIssueListColumns } from './hooks';

export const IssueList = (props: {
  data: CompositedSignalIssue[];
  dynamicFilterSet: StructuredFilter;
  datePreset: SignalDateSelectionInput;
  emptyTitle?: string;
}) => {
  const { data, dynamicFilterSet, datePreset, emptyTitle } = props;
  const { columns } = useIssueListColumns({
    dynamicFilterSet,
    datePreset,
  });
  const { navigateToIssueDetailPage } = useIssueListActions();

  const slicedData = useMemo(
    () => data.slice(0, MAX_DISPLAY_ISSUE_COUNT),
    [data],
  );

  return (
    <div className="w-full h-full bg-background overflow-hidden">
      <DataTable
        columns={columns}
        data={slicedData}
        emptyState={<DataTableEmpty title={emptyTitle ?? 'No issues yet'} />}
        headerClassName="bg-muted text-muted-foreground"
        onClickRow={(rowData) => {
          track(AMP_KEYS.SIGNAL_ISSUE_DETAIL_VIEW, {
            issue_name: rowData.name,
            severity: rowData.severity,
            view_type: 'row_click',
          });
          navigateToIssueDetailPage(
            rowData.name,
            dynamicFilterSet,
            datePreset,
          );
        }}
      />
    </div>
  );
};
